import React from 'react';

/**
 * Contrôle tapotable dont le contenu visible est une icône.
 *
 * C'est le cas où le nom accessible manque le plus souvent, et celui que #34 a
 * relevé comme défaut bloquant sur la maquette. Ici `libelle` est requis par le
 * typage et part en `aria-label` : un lecteur d'écran annonce toujours quelque
 * chose, et `tsc --noEmit` refuse l'oubli.
 *
 * La zone tactile fait 44 px dans les deux dimensions, quelle que soit la taille
 * de l'icône (#34 : la zone est plancher, le visible est libre).
 */
interface IconButtonProps {
    /** Nom accessible. Jamais affiché — l'icône est le visible. */
    libelle: string;
    onPress: () => void;
    children: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

export default function IconButton({
    libelle,
    onPress,
    children,
    disabled = false,
    className = '',
}: IconButtonProps) {
    return (
        // mobile-check-ignore — socle : voir Button.tsx
        <button
            type="button"
            aria-label={libelle}
            onClick={onPress}
            disabled={disabled}
            className={[
                'inline-flex min-h-touch min-w-touch items-center justify-center rounded-full',
                'text-text-color disabled:opacity-50',
                className,
            ]
                .filter(Boolean)
                .join(' ')}
        >
            {children}
        </button>
    );
}
